<script lang="ts">
    import { Label } from "attractions";
    import { afterUpdate } from "svelte";

    export let title: string = '';

    let cardsContainer: HTMLDivElement;
    let hasCards: boolean = true;

    afterUpdate(() => {
        if (cardsContainer.innerHTML) hasCards = true;
        else hasCards = false;
    });
</script>

{#if hasCards}
    <section class="groupOfSimilar">
        <Label style="margin-bottom: .75rem; color: white; font-size: .9rem">{title}</Label>
        <div bind:this={cardsContainer} class="cards">
            <slot></slot>
        </div>
    </section>
{/if}

<style lang="scss">
    .groupOfSimilar {
        display: flex;
        padding: 1rem 1.5rem;
        flex-direction: column;
        background-repeat: repeat;
        border-radius: 21px;
        margin-right: 1rem;

        @media (max-width: 768px) {
            margin: 0;
        }

        &:last-of-type {
            margin-right: 0;
        }

        .cards {
            display: flex;
            align-items: center;

            @media (max-width: 768px) {
                flex-direction: column;
            }
        }
    }
</style>

